import { createActions } from "redux-actions";

export const {
  setGroups,
  setGroupsLoading,
  setGroupsOpenedNodes,
  updateGroupName,  
} = createActions({
  SET_GROUPS_OPENED_NODES: ({ items }) => ({ items }),
  SET_GROUPS: ({ items }) => ({ items }),
  SET_GROUPS_LOADING: ({ loading }) => ({ loading }),  
  UPDATE_GROUP_NAME: ({ groupId, newName, newGroupLookup }) => ({ groupId, newName, newGroupLookup }),
});
